import React, { useEffect, useMemo, useState } from "react";
import { StyleSheet } from "react-native";
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import { useIsFocused, useNavigation } from "@react-navigation/native";
import ListItem from 'theme/ListItem';
import Text from "theme/Text";
import { useSelector } from "react-redux";
import i18n from "utils/i18n";
import Translate from "utils/translate";
import _ from "lodash";
import { listArrow, listStyles } from "styles/list";
import { AppRoutes } from "navigations/app-routes";
import LoadingComponent from "components/atoms/Loading";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedList from 'components/atoms/ThemedList'
import ThemedBlockListContainer from 'components/atoms/ThemedBlockListContainer'
import HelperString from 'utils/helper-string'
import { managementConstants } from 'services/redux/management/constants'
import { fetchManagementBuildingTimeslots } from 'scenes/management/bookings/_functions/timeslots'
import { useShowHamburger } from 'utils/helper-device'
import { selectManagementSelectedStartDate } from 'services/redux/management/reducers'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const ManagementBookingsValidateIndexScene = () => {
	
	const isFocused = useIsFocused();
	const navigation = useNavigation();
	const showHamburger = useShowHamburger()
	
	const _selectedStartDate = useSelector( selectManagementSelectedStartDate )
	const _managementBuildings = useSelector( state => {
		return state.management[managementConstants.BUILDINGS];
	} )
	
	const [ loading, setLoading ] = useState( true )
	
	const fetchBuildings = () => {
		if( !isFocused ) {
			return;
		}
		
		fetchManagementBuildingTimeslots( null, null, {
			callbackStart: setLoading.bind( this, true ),
			callbackSuccess: setLoading.bind( this, false ),
			callbackError: setLoading.bind( this, false ),
		})
	}
	
	const viewItemDetails = ( building, floor = null, room = null ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_BOOKINGS_VALIDATE_INDEX, {
			'buildingGuid': building.guid,
		});
	}
	
	const RenderItem = ({ building, item }) => {
		return (
			<ListItem
				key={ HelperString.hash('listItem', item ) }
				onPress={ viewItemDetails.bind( this, building, item ) }
				style={ [
					listStyles.listItem,
					styles.listItem
				]}>
				
				<Grid>
					<Container>
						<Column>
							<Row align={'center'}>
								<Column auto>
									<Text>{ Translate.field( item, 'title' ) }</Text>
								</Column>
								<Column auto>
									{ listArrow }
								</Column>
							</Row>
						</Column>
					</Container>
				</Grid>
			</ListItem>
		)
	}
	
	useEffect( () => {
		return fetchBuildings();
	}, [ isFocused, _selectedStartDate] )
	
	const content = useMemo( () => {
		if( loading ) {
			return (
				<LoadingComponent />
			)
		}
		
		return _.map( _managementBuildings, building => {
			// Variable to only show the building and not the floors/rooms
			const floors = [];
			floors.unshift({
				isBuilding: true,
				name: i18n.t('management:generic.view_all_from', {
					name: Translate.field( building, 'title' )
				} )
			});
			
			return (
				<ThemedBlock
					key={ HelperString.hash( 'building-block-index', building )}
					header={ Translate.field( building, 'title' ) }
					shadow
					smallPadding>
					
					<ThemedBlockListContainer>
						<ThemedList
							data={ floors }
							renderItem={ ( { item, index } ) => {
								return (
									<RenderItem
										building={ building }
										item={ item }
									/>
								);
							} }
						/>
					</ThemedBlockListContainer>
				</ThemedBlock>
			);
		});
	}, [ loading, _managementBuildings ])
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:menu.bookings_validate' ) }
				topNavigation={ true }
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					{ content }
				</VStack>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	listItem: {
		paddingVertical: 8
	},
});

export default ManagementBookingsValidateIndexScene
